"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CheckList_1 = require("../../../javascript/ProdSys/CheckList");
const Utilities_1 = require("../../../javascript/Utilities");
const Instance_1 = require("../../../model/Instance");
exports.default = {
    impl: (ids, parentId, relId, completedHandler) => {
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("InstanceMultiple"),
            requestData: { ids: ids.join(";"), properties: "cgdocument.prodid" },
            done: (data) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                for (let docId in data) {
                    let instance = yield Instance_1.Instance.fromJSON(data[docId]);
                    CheckList_1.Checklist.View(instance);
                }
            })
        });
    }
};
